import LocalizedStrings from "react-localization";
import en from "./en.json";
import ar from "./ar.json";

const Locale = new LocalizedStrings({ en, ar });

export default Locale;
